import React, { Component } from 'react';
import {
    AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

var moment = require('moment');

function getRandomIntRange(min, max) {

    //based on MDN documentation
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}

const data = [];
let default_max = 10000;
let default_min = 1;

for (var i = 0; i < 30; i++) {
    data.push({
        name: moment().subtract(i, 'days').format('MMM Do'),
        'Users Online': getRandomIntRange(default_min, default_max),
        amt: 10000
    });
}

data.reverse();

class CustomYAxisLabel extends Component {
    render() {
        const {
            stroke, name, height
        } = this.props;

        // place the x axis label centrally based on the height of the graph
        const x_co = (height / 2) * -1;
        return <text style={{ fontWeight: 500, fill: '#141414' }} x={x_co} y={20} transform="rotate(-90)" dy={-4} fill={stroke} fontSize={14} textAnchor="middle">{name}</text>;
    }
}

class CustomActiveDot extends Component {
    render() {
        const {
            cx, cy, color
        } = this.props;

        return (
            <svg>
                <circle cx={cx} cy={cy} strokeWidth="2" opacity={0.2} fill={color} r="12.5" ></circle>
                <circle cx={cx} cy={cy} strokeWidth="2" stroke={`${color}`} fill="white" r="6" ></circle>
            </svg>
        );
    }
}

const CustomTooltip = ({ active, payload, label, name, custom_tooltip_label_1 }) => {
    if (active && Array.isArray(payload) && payload.length > 0) {
        const visible_payload = payload.filter(item => item && typeof item.value !== 'undefined');
        return (
            <div className="solvably-graph-tooltip">
                <p className="name m-0">{custom_tooltip_label_1 ? custom_tooltip_label_1 : name}</p>
                <p className="date m-0 mb-2">{label}</p>
                {visible_payload.map(item => (
                    <p key={item.dataKey} className="number m-0 mb-1">{item.name}: {item.value}</p>
                ))}
            </div>
        );
    }

    return null;
};

/**
 * Recharts basic Stacked Area Graph extended to match the Solvably style guide, with custom tooltips and hover indicators
 *
 * @props
 * - color: string(css color, hex value, rgb value), default line color
 * - height: int/string, height of the parent container for responsive graphs, may NOT be a percentage based height
 * - width: int/string, width of the parent container for responsive graphs, may be percentage based
 * -
 * - legend: boolean, determines whether to show a legend with the graph
 * - dep_label: string, name of the dependent variable (the Y Axis)
 * - custom_tooltip_label_1: string (optional), change the first tooltip (default is the dependent variable label) label's contents
 * - margin: Object, {
 *     top: int, pixels of margin between the graph and the graph's own container top,
 *     right: right: int, pixels of margin between the graph and the graph's own container,
 *     left: left: int, pixels of margin between the graph and the graph's own container,
 *     bottom: bottom: int, pixels of margin between the graph and the graph's own container
 * }
 * - Data: Array of Objects, [{
 *           name: string/int, value of the independent variable (X Axis),
 *           [props.dep_label]: value of the dependent variable (Y Axis),
 *           amt: int(optional), the maximum amount to show while graphing this value even is [prop.name] is larger
 *       }]
 *
 * Usage:
 * <GMetrixStackedArea />
 */
class GMetrixStackedArea extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    static defaultProps = {
        color: '#365a8f',
        height: 350,
        width: '100%',
        data,
        dep_label: 'Users Online',
        legend: false,
        margin: {
            top: 5, right: 5, left: 5, bottom: 0
        },
        custom_tooltip_label_1: null,
        x_data_key: 'name',
        y_data_keys: null,
        series_colors:
            [
                "#FFA61A", // Vibrant Orange
                "#33C27F", // Vibrant Green
                "#009C8C", // Deep Teal
                "#6B49FF", // Bold Purple
                "#1E8CFF", // Electric Blue
                "#FFCC00" // Warm Gold
            ],
        series_labels: {}
    };

    render() {
        const { data, height, width, color, dep_label, legend, margin, custom_tooltip_label_1, x_data_key, y_data_keys, series_colors, series_labels } = this.props;
        const light_grey = '#d1d1d1';
        const series_keys = Array.isArray(y_data_keys) && y_data_keys.length > 0 ? y_data_keys : [dep_label];

        if (!data)
            return <div>-</div>;

        return (
            <>
                <div style={{ width, height }}>
                    <ResponsiveContainer
                        width="100%"
                        height="100%"
                    >
                        <AreaChart
                            data={data}
                            margin={margin}
                        >
                            <CartesianGrid vertical={false} stroke={light_grey} />
                            <XAxis dataKey={x_data_key} />
                            {legend && <Legend />}
                            <YAxis label={<CustomYAxisLabel height={height} name={dep_label} />} />
                            <Tooltip content={<CustomTooltip name={dep_label} custom_tooltip_label_1={custom_tooltip_label_1} />} />
                            {series_keys.map((key, index) => {
                                const series_color = GMetrixStackedArea.defaultProps.series_colors[index];

                                debugger;
                                return (
                                    <Area
                                        key={key}
                                        activeDot={index === 0 ? <CustomActiveDot color={series_color} /> : false}
                                        dot={false}
                                        type="monotone"
                                        dataKey={key}
                                        name={series_labels?.[key] || key}
                                        stackId="1"
                                        stroke={series_color}
                                        fill={series_color}
                                        strokeWidth={2}
                                        opacity={0.65}
                                    />
                                );
                            })}
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            </>
        );
    }
}

export default GMetrixStackedArea;
